import { useCallback, useState } from 'react';

export const useCarouselUtils = (totalSlides = 0) => {
  const [swiperRef, setSwiperRef] = useState<any>();
  const [current, setCurrent] = useState(0);

  const handlePrevious = useCallback(() => {
    let slideTo;

    if (current - 1 === -1) {
      slideTo = totalSlides - 1;
    } else {
      slideTo = current - 1;
    }
    setCurrent(slideTo);

    swiperRef?.slideTo(slideTo);
  }, [current, swiperRef, totalSlides]);

  const handleNext = useCallback(() => {
    let slideTo;

    if (current + 1 === totalSlides) {
      slideTo = 0;
    } else {
      slideTo = current + 1;
    }
    setCurrent(slideTo);
    swiperRef?.slideTo(slideTo);
  }, [current, swiperRef, totalSlides]);

  return {
    handlePrevious,
    handleNext,
    setSwiperRef,
    setCurrent,
    swiperRef,
    current,
  };
};
